export enum TenantPermissions {
  CanPerformTemplatesMgtAdmin = "can_perform_templates_mgt_admin",
}
